module.exports = __webpack_public_path__ + "static/media/purchase-chest-legend.31259294.png";